import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import Select from 'react-select';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import moment from 'moment';
import PropTypes from 'prop-types';
import { customStyle, formatNumber } from 'helper';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as action from '../action';
import * as c from '../constant';
// import UpdatePinModalContainer from './UpdatePinModalContainer';

import { DISPATCHED_OTP_DATA } from '../../general-settings/otpModule/constant';

function ProfileEditModal({
  updating,
  taxpayers,
  taxpayerId,
  setFormData,
  formData,
  createSelect,
  createInput,
  createUploader,
  // createInputMobileNumber,
  getRegionsList,
  getProvinceList,
  getMunicipalityList,
  getBarangayList,
  regionsList,
  municipalityList,
  provinceList,
  updateProfile,
  showTransaction,
  handleVerifyOtp,
}) {
  const setModal = useContext(ModalContext);
  // fetch registered_account and change_mobile_number from OTPModuleContent.js
  const otpModuleData = useSelector(({ api }) =>
    _.get(api, `${DISPATCHED_OTP_DATA}.item`)
  );

  const [formMobile, setFormMobile] = useState({});

  const [region, setRegion] = useState({
    label: _.get(taxpayers, 'attributes.place_of_birth_region_name') || '',
    value: _.get(taxpayers, 'attributes.place_of_birth_region_code') || '',
  });

  const [province, setProvince] = useState({
    label: _.get(taxpayers, 'attributes.place_of_birth_province_name') || '',
    value: _.get(taxpayers, 'attributes.place_of_birth_province_code') || '',
  });

  const [municipality, setMunicipality] = useState({
    label:
      _.get(taxpayers, 'attributes.place_of_birth_municipality_name') || '',
    value:
      _.get(taxpayers, 'attributes.place_of_birth_municipality_code') || '',
  });

  const updateData = () => {
    showTransaction(taxpayerId);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      first_name: _.get(formData, 'first_name')
        ? _.get(formData, 'first_name').toUpperCase()
        : '',
      middle_name: _.get(formData, 'middle_name')
        ? _.get(formData, 'middle_name').toUpperCase()
        : '',
      last_name: _.get(formData, 'last_name')
        ? _.get(formData, 'last_name').toUpperCase()
        : '',
      mobile_number: _.get(formMobile, 'mobile_number'),
      photo: _.get(formData, 'photo.cdnUrl'),
      birth_date: _.get(formData, 'birth_date')
        ? `${moment(_.get(formData, 'birth_date')).format('MM/DD/YYYY')}`
        : '',
      mother_maiden_first_name: _.get(formData, 'mother_maiden_first_name')
        ? _.get(formData, 'mother_maiden_first_name').toUpperCase()
        : '',
      mother_maiden_last_name: _.get(formData, 'mother_maiden_last_name')
        ? _.get(formData, 'mother_maiden_last_name').toUpperCase()
        : '',
      mother_maiden_middle_name: _.get(formData, 'mother_maiden_middle_name')
        ? _.get(formData, 'mother_maiden_middle_name').toUpperCase()
        : '',
    };

    updateProfile(taxpayerId, args, () => {
      if (
        _.get(formMobile, 'mobile_number') ===
        taxpayers.attributes.mobile_number
      ) {
        updateData();
      }
      if (
        _.get(formMobile, 'mobile_number') !==
          taxpayers.attributes.mobile_number &&
        _.get(otpModuleData, 'change_mobile_number') === 0
      ) {
        updateData();
      }
      if (
        _.get(formMobile, 'mobile_number') !==
          taxpayers.attributes.mobile_number &&
        _.get(otpModuleData, 'change_mobile_number') === 1
      ) {
        handleVerifyOtp();
      }
      setModal({ isOpen: false });
    });
  };

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleOnChangeSelect = (name) => (data) => {
    setFormData({
      ...formData,
      [name]: data.value,
    });
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleRegionSelect = (e) => {
    setRegion(e);
    setFormData({
      ...formData,
      place_of_birth_region_code: e.value,
    });
    getProvinceList({ region_code: e.value });
  };

  const handleProvinceSelect = (e) => {
    setProvince(e);
    setFormData({
      ...formData,
      place_of_birth_province_code: e.value,
    });
    getMunicipalityList({ province_code: e.value });
  };

  const handleMunicipalitySelect = (e) => {
    setMunicipality(e);
    setFormData({
      ...formData,
      place_of_birth_municipality_code: e.value,
    });
    getBarangayList({ municipality_code: e.value });
  };

  const OnSetFormData = () => {
    setFormMobile({
      mobile_number: formatNumber(taxpayers.attributes.mobile_number || ''),
    });

    setFormData({
      photo: taxpayers.attributes.photo,
      is_resident: taxpayers.attributes.is_resident,
      first_name: taxpayers.attributes.first_name || '',
      last_name: taxpayers.attributes.last_name || '',
      middle_name: taxpayers.attributes.middle_name || '',
      mobile_number: formatNumber(taxpayers.attributes.mobile_number || ''),
      telephone_number: taxpayers.attributes.telephone_number || '',
      email: taxpayers.attributes.email || '',
      user_id: taxpayers.attributes.user_id || '',
      birth_date: taxpayers.attributes.birth_date || '',

      street: taxpayers.attributes.street,
      civil_status: taxpayers.attributes.civil_status,
      gender: taxpayers.attributes.gender,
      place_of_birth_region_code:
        taxpayers.attributes.place_of_birth_region_code,
      place_of_birth_municipality_code:
        taxpayers.attributes.place_of_birth_municipality_code,
      place_of_birth_province_code:
        taxpayers.attributes.place_of_birth_province_code,
      extension_name: taxpayers.attributes.extension_name,
      mother_maiden_first_name: taxpayers.attributes.mother_maiden_first_name,
      mother_maiden_last_name: taxpayers.attributes.mother_maiden_last_name,
      mother_maiden_middle_name: taxpayers.attributes.mother_maiden_middle_name,
      is_user_id_auth: taxpayers.attributes.is_user_id_auth,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(taxpayers)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    getRegionsList();

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  useEffect(() => {
    getProvinceList({
      region_code: _.get(taxpayers, 'attributes.place_of_birth_region_code'),
    });
  }, []);

  useEffect(() => {
    getMunicipalityList({
      province_code: _.get(
        taxpayers,
        'attributes.place_of_birth_province_code'
      ),
    });
  }, []);

  useEffect(() => {
    getBarangayList({
      municipality_code: _.get(
        taxpayers,
        'attributes.place_of_birth_municipality_code'
      ),
    });
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row d-flex justify-content-center text-primary">
          Personal Information
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="full-group ">
              <div className="row d-flex justify-content-center">
                <div className="col-12">
                  <img
                    className="w-100 rounded"
                    src={
                      !_.isObject(_.get(formData, 'photo') || '')
                        ? _.get(formData, 'photo') || ImagePlaceholder
                        : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
                    }
                    alt=""
                  />
                </div>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="col-12 form-group">
                  {createUploader(
                    { key: 'photo', label: 'Browse' },
                    { required: true }
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9 row">
            <div className="col-4 form-group">
              {createInput(
                { key: 'first_name', label: 'First Name' },
                {
                  required: true,
                  className: 'form-control text-uppercase',
                  placeholder: 'First Name',
                }
              )}
            </div>
            <div className="col-4 form-group">
              {createInput(
                { key: 'middle_name', label: 'Middle Name' },
                {
                  required: false,
                  placeholder: 'Middle Name',
                  className: 'text-uppercase form-control',
                }
              )}
            </div>
            <div className="col-4 form-group">
              {createInput(
                { key: 'last_name', label: 'Last Name' },
                {
                  required: true,
                  placeholder: 'Last Name',
                  className: 'text-uppercase form-control',
                }
              )}
            </div>

            <div className="col-4 form-group">
              {createSelect(
                {
                  required: true,
                  placeholder: 'Extension Name',
                  key: 'extension_name',
                  label: 'Extension Name',
                },
                c.EXTENSION_NAMES
              )}
            </div>

            <div className="col-4 form-group">
              {createInput(
                { key: 'email', label: 'Email' },
                { required: false, placeholder: 'Email', type: 'email' }
              )}
            </div>
            <div className="col-4 form-group">
              {/* {createInputMobileNumber(
                { key: 'mobile_number', label: 'Mobile No.:' },
                { placeholder: 'Mobile No.' }
              )} */}
              <label className="form-label">Mobile Number:</label>
              <FormInputMobile
                disableDropdown={false}
                autoComplete="off"
                autoFocus
                type="tel"
                name="mobile_number"
                onChange={setFormMobile}
                value={_.get(formMobile, 'mobile_number')}
              />
            </div>
            <div className="col-4 form-group">
              <label className="form-label">Civil Status:</label>
              <Select
                styles={customStyle}
                value={
                  c.CIVIL_STATUSES.find(
                    (item) =>
                      _.get(formData, 'civil_status') === _.get(item, 'value')
                  ) || ''
                }
                onChange={handleOnChangeSelect('civil_status')}
                options={c.CIVIL_STATUSES}
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="gender" className="form-label">
                Gender
                <span className="text-danger">
                  <i>Required</i>
                </span>
              </label>
              <Select
                styles={customStyle}
                value={
                  c.GENDERS.find(
                    (item) => _.get(formData, 'gender') === _.get(item, 'value')
                  ) || ''
                }
                onChange={handleOnChangeSelect('gender')}
                options={c.GENDERS}
              />
            </div>
            <div className="col-4 form-group">
              <label className="form-control-plaintext form-label">
                Birthdate:{' '}
                <span className="text-danger">
                  <i>Required</i>
                </span>
              </label>
              <DateInputPicker
                className="full-input"
                onChange={handleOnChangeDate('birth_date')}
                value={_.get(formData, 'birth_date') || ''}
                // value={`${
                //   _.get(formData, 'birth_date')
                //     ? moment(_.get(formData, 'birth_date')).format('YYYY-MM-DD')
                //     : null
                // }`}
                maxDate={new Date()}
              />
            </div>
          </div>
        </div>

        <hr />
        <div className="row d-flex justify-content-center text-primary">
          Place of Birth
        </div>
        <div className="row">
          <div className="col-4 form-group">
            <label className="form-label">
              Region:
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>
            <Select
              styles={customStyle}
              placeholder="Select Region"
              value={region}
              options={createDropdown(regionsList)}
              onChange={(e) => {
                handleRegionSelect(e);
              }}
            />
          </div>
          <div className="col-4 form-group">
            <label className="form-label">
              Province:
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>
            <Select
              value={province}
              styles={customStyle}
              placeholder="Select Province"
              options={createDropdown(provinceList)}
              onChange={(e) => {
                handleProvinceSelect(e);
              }}
            />
          </div>
          <div className="col-4 form-group">
            <label className="form-label">
              Municipality:
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>
            <Select
              options={createDropdown(municipalityList)}
              styles={customStyle}
              placeholder="Select Municipality"
              value={municipality}
              onChange={(e) => {
                handleMunicipalitySelect(e);
              }}
            />
          </div>
        </div>
        <hr />
        <div className="row d-flex justify-content-center text-primary">
          Document Owner&apos;s Mother Information
        </div>
        <div className="row">
          <div className="col-4 form-group">
            {createInput(
              { key: 'mother_maiden_first_name', label: 'Mother First Name' },
              {
                placeholder: 'Input mother first name',
                className: 'text-uppercase form-control',
              }
            )}
          </div>
          <div className="col-4 form-group">
            {createInput(
              { key: 'mother_maiden_last_name', label: 'Mother Last Name' },
              {
                placeholder: 'Input mother last name',
                className: 'text-uppercase form-control',
              }
            )}
          </div>
          <div className="col-4 form-group">
            {createInput(
              {
                key: 'mother_maiden_middle_name',
                label: 'Mother Middle Name',
              },
              {
                placeholder: 'Input mother middle name',
                className: 'text-uppercase form-control',
              }
            )}
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark"
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
ProfileEditModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  taxpayerId: PropTypes.string.isRequired,
  taxpayers: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  //   history: PropTypes.instanceOf(Object).isRequired,
  updateProfile: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  // createInputMobileNumber: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  handleVerifyOtp: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_PROFILE) > -1,
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ProfileEditModal);
